<template>
  <div class="dropdown-container" :class="{ 'menu-open': isMenuOpen }" v-click-outside="closeMenu">
    <div class="dropdown-btn" @click="toggleMenu">
      {{ selectedOption() }}
      <span class="chevron">
        <!-- <i>▼</i> -->
        <van-icon name="arrow-down" />
      </span>
    </div>

    <transition name="scale">
      <div v-if="isMenuOpen" class="menu-items">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="menu-item"
          :class="{ selected: item.value === selectedValue }"
          @click="selectItem(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "DropdownMenu",
  props: {
    items: {
      type: Array,
      default: () => [
        { label: "选项一", value: 1 },
        { label: "选项二", value: 2 },
        { label: "选项三", value: 3 },
      ],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  emits: ["change"],
  // directives: {
  //   'click-outside': {
  //     beforeMount(el, binding) {
  //       // 处理点击外部事件
  //       el.clickOutsideEvent = function(event) {
  //         // 检查点击是否在元素外部
  //         if (!(el === event.target || el.contains(event.target))) {
  //           // 调用绑定的方法
  //           binding.value(event)
  //         }
  //       }
  //       // 添加全局点击监听
  //       document.addEventListener('click', el.clickOutsideEvent)
  //     },
  //     unmounted(el) {
  //       // 组件卸载时移除事件监听
  //       document.removeEventListener('click', el.clickOutsideEvent)
  //     }
  //   }
  // },
  setup(props, { emit }) {
    const store = useStore();
    const isMenuOpen = ref(false);
    const selectedValue = ref(store.state.language);
    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value;
    };

    const closeMenu = () => {
      if (isMenuOpen.value) {
        isMenuOpen.value = false;
      }
    };

    const selectItem = (item) => {
      selectedValue.value = item.value;
      closeMenu();
      emit("change", item);
    };

    const selectedOption = () => {
      const selected = props.items.find(
        (item) => item.value === selectedValue.value
      );
      return selected ? selected.label : "";
    };

    return {
      isMenuOpen,
      selectedValue,
      toggleMenu,
      closeMenu,
      selectItem,
      selectedOption,
    };
  },
};
</script>

<style scoped>
.dropdown-container {
  position: relative;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  color: #333333;
}

.dropdown-btn {
  border-radius: 8px;
  /* padding: 10px 16px; */
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  /* width: 100%; */
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
}

/* .dropdown-btn:hover {
  border-color: #3498db;
  box-shadow: 0 3px 10px rgba(52, 152, 219, 0.15);
} */

/* .dropdown-btn:focus {
  outline: none;
  border-color: #3498db;
} */

.chevron {
  transition: transform 0.3s;
}

.menu-open .chevron {
  transform: rotate(180deg);
}

/* 缩放动画效果 */
.scale-enter-active,
.scale-leave-active {
  transition: all 0.25s ease;
  transform-origin: top center;
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.menu-items {
  position: absolute;
  top: calc(100% + 8px);
  /* left: 0; */
  right: 0;
  /* width: 100%; */
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;
}

.menu-item {
  padding: 10px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  /* border-bottom: 1px solid #f5f5f5; */
  text-align: center;
  white-space: nowrap;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  background-color: #f8f9ff;
  padding-left: 20px;
}

.menu-item.selected {
  color: var(--main-bg-color);
  font-weight: 500;
}
</style>
